var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrademark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 122.88 55.84"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h52.45v13.8h-17.6v42.05H17.59V13.8H0zm60.07 0h22.7l8.76 33.97L100.26 0h22.62v55.84h-14.1V13.26L97.85 55.84H85.1L74.2 13.26v42.58H60.07z"
})));
export { SvgTrademark as ReactComponent };
export default __webpack_public_path__ + "static/media/trademark.67af55d7.svg";